/**
 * Author: BaiJiFeiLong@gmail.com
 * Datetime: 2017/4/11 下午6:04
 */

import React, {Component} from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/lib/Modal";
import Form from "react-bootstrap/lib/Form";
import FormControl from "react-bootstrap/lib/FormControl";
import Button from "react-bootstrap/lib/Button";
import ChordGraph from "./ChordGraph";
import {connect} from "react-redux";
import * as selectors from "../reducers/selectors";
import * as actions from "../actions/index";
import * as MaterialsHelper from "../helpers/MaterialsHelper";

@connect((state) => {
    const chordsChooserState = selectors.chordsChooserSelector(state);
    return {...chordsChooserState};
}, {
    onOk: (chord) => actions.chordsChooserOk(chord),
    onCancel: () => actions.chordsChooserCancel(),
    onCustom: () => actions.chordsChooserCustom(),
    onQueryChords: (condition) => actions.requestChordsChooserChords(condition),
    onSelect: (index) => actions.updateChordsChooserSelectedIndex(index)
})
export default class ChordsChooser extends Component {
    static propTypes = {
        onOk: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onCustom: PropTypes.func.isRequired,
        onQueryChords: PropTypes.func.isRequired,
        onSelect: PropTypes.func.isRequired,
        isVisible: PropTypes.bool.isRequired,
        instrumentType: PropTypes.string.isRequired,
        activePrefixIndex: PropTypes.number.isRequired,
        selectedIndex: PropTypes.number.isRequired,
        chords: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    componentDidMount() {
        const {instrumentType, activePrefixIndex, onQueryChords} = this.props;
        const prefix = MaterialsHelper.chordPrefixes[instrumentType][activePrefixIndex];
        onQueryChords({instrumentType, prefix});
    }

    render() {
        const {
            isVisible, onOk, onCancel, onCustom, chords, activePrefixIndex, selectedIndex, instrumentType,
            onQueryChords, onSelect
        } = this.props;
        const prefixes = MaterialsHelper.chordPrefixes;
        const activePrefix = prefixes[instrumentType][activePrefixIndex];
        const activeChord = chords[selectedIndex];
        return (
            <Modal.Dialog style={{display: isVisible ? 'block' : 'none'}}>
                <Modal.Header>
                    <Modal.Title>选择和弦</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <Form inline>
                            <FormControl
                                value={instrumentType}
                                componentClass="select" bsSize="sm"
                                style={{minWidth: 50 + 'px'}}
                                onChange={(e) => onQueryChords({
                                    instrumentType: e.target.value,
                                    prefix: prefixes[instrumentType][0]
                                })}
                            >
                                <option value="guitar">吉他</option>
                                <option value="ukulele">尤克里里</option>
                            </FormControl>
                            <FormControl
                                componentClass="select" bsSize="sm"
                                style={{minWidth: 50 + 'px', marginLeft: 5 + 'px'}}
                                value={activePrefixIndex}
                                onChange={(e) => onQueryChords({prefix: prefixes[instrumentType][e.target.value]})}
                            >
                                {
                                    prefixes[instrumentType].map((prefix, index) => {
                                        return (
                                            <option key={index} value={index}>{prefix}</option>
                                        )
                                    })
                                }
                            </FormControl>
                            <FormControl
                                value={selectedIndex}
                                componentClass="select" bsSize="sm"
                                style={{marginLeft: 5 + 'px', minWidth: 50 + 'px'}}
                                onChange={(e) => onSelect(e.target.value)}
                            >
                                {
                                    chords.map((chord, index) => {
                                        return (
                                            <option key={index}
                                                    value={index}>{chord.name.substring(activePrefix.length)}</option>
                                        )
                                    })
                                }
                            </FormControl>
                        </Form>
                        {
                            activeChord ?
                                <ChordGraph
                                    style={{marginTop: 10 + 'px'}}
                                    baseFret={activeChord.baseFret}
                                    frets={activeChord.frets}
                                    fingers={activeChord.fingers}
                                />
                                : <span>未选中和弦</span>
                        }
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={onCustom} bsStyle="warning">自定义</Button>
                    <Button
                        bsStyle="primary"
                        onClick={() => onOk(activeChord)}
                        disabled={!activeChord}>确定</Button>
                    <Button onClick={onCancel}>取消</Button>
                </Modal.Footer>
            </Modal.Dialog>
        )
    }
}




// WEBPACK FOOTER //
// src/components/ChordsChooser.js